import {service} from '@/api-services'
import {paginationHandler, parseLinkHeader} from '@/utils/common'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useServiceStore = defineStore('serviceStore', {
  state: () => ({
    allServices: [],
    services: [],
    serviceDetail: {},
    isCreateSuccess: false,
    isUpdateSuccess: false,
    loading: false,
    servicesLink: {},
    error: null,
    currentPage: {
      services: 1,
    },
    perPage: 20,
  }),
  getters: {
    getServicesWithSerialNumber(state) {
      return state.services.map((val, index) => ({
        ...val,
        serialNumber: (state.currentPage.services - 1) * state.perPage + index + 1,
      }))
    },
    getThreeServices(state) {
      return state.services.slice(0, 3)
    },
  },
  actions: {
    async getAllServices(query) {
      this.loading = true
      try {
        const response = await service.get(query)
        const data = response.data
        this.allServices = data
        this.services = data
        this.servicesLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getServiceById(id) {
      this.loading = true
      try {
        const response = await service.getById(id)
        const data = response.data
        this.serviceDetail = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async addService(payload) {
      this.loading = true
      try {
        const response = await service.create(payload)
        const data = response.data
        this.serviceDetail = data
        this.isCreateSuccess = true
        toast.success(successHandler('CREATE_SERVICE_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async updateService(id, payload) {
      this.loading = true
      try {
        const response = await service.update(id, payload)
        const data = response.data
        this.serviceDetail = data
        this.isUpdateSuccess = true
        toast.success(successHandler('UPDATE_SERVICE_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async deleteService(id) {
      this.loading = true
      try {
        await service.delete(id)
        toast.success(successHandler('DELETE_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getTablePagination(page, type) {
      if (type) {
        this[`${type}Loading`] = true
      } else {
        this.loading = true
      }
      let response = []
      try {
        if (page === 'next') {
          this.currentPage[type] += 1
          response = await paginationHandler(this[`${type}Link`].next)
        } else if (page === 'prev') {
          this.currentPage[type] -= 1
          response = await paginationHandler(this[`${type}Link`].prev)
        }
        this[type] = response.data
        if (type) {
          this[`${type}Link`] = parseLinkHeader(response.headers.link)
        } else {
          this.link = parseLinkHeader(response.headers.link)
        }
      } catch (error) {
        const errorMsg = errorHandler(error)
        this.error = errorMsg
        toast.error(errorMsg)
      } finally {
        if (type) {
          this[`${type}Loading`] = false
        } else {
          this.loading = false
        }
      }
    },
  },
})
